import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=47349a4b"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pppppat/Documents/GitHub/sp-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47349a4b')) {
      api.createRecord('47349a4b', component.options)
    } else {
      api.reload('47349a4b', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=47349a4b", function () {
      api.rerender('47349a4b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/convalescenceSystem/convalescenceNotice/detail.vue"
export default component.exports